import React, { useState, useEffect } from 'react';
import CommonSearchCriteria from '../common/CommonSearchCriteria';
import Quotes from './Quotes';
import InvoicesTable from './InvoicesTable';
import { GetInvoices } from '../../services/InvoiceService';
import CommonLoader from '../common/CommonLoader';
import { NotificationManager } from 'react-notifications';
import { Button } from "@mui/material";
import { invoiceStatusList } from '../common/statusLists';  

const Invoices = () => {
  //const previousStatusList = ['Paid', 'Pricing', 'Reviewed', 'Sent', 'Unreviewed'];

  const [loading, setLoading] = useState(false);
  const [invoicesData, setInvoicesData] = useState(null);
  const [showQuotes, setShowQuotes] = useState(false);

  useEffect(() => {
    const today = new Date();
    const startDateValue = new Date(today);
    startDateValue.setDate(today.getDate() - 15);
    const endDateValue = new Date(today);
    endDateValue.setDate(today.getDate() + 15);

    const initialCriteria = {
      searchText: '',
      orderStatus: 'Pricing',
      startDate: startDateValue.toISOString().split('T')[0],
      endDate: endDateValue.toISOString().split('T')[0],
    };

    getInvoices(initialCriteria);
  }, []);

  const getInvoices = async (searchCriteria) => {
    try {
      setLoading(true);
      let response = await GetInvoices(
        searchCriteria.startDate,
        searchCriteria.endDate,
        searchCriteria.orderStatus,
        searchCriteria.searchText,
        1
      );

      setInvoicesData(response.results);
    } catch (err) {
      NotificationManager.error('Error getting invoices. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCriteria = async (searchCriteria) => {
    getInvoices(searchCriteria);
  };

  const toggleComponent = () => {
    setShowQuotes(!showQuotes);
  };

  return (
    <div className="vlp-component-container">
      {/* Invoices Header Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span className="title">{showQuotes ? '' : 'Invoices'}</span>
        {/* <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={toggleComponent}
          style={{ height: '100%', marginRight: '20px' }}
        >
          {showQuotes ? 'Switch to Invoices' : 'Switch to Quotes'}
        </Button> */}
      </div>
      <hr />

      {/* CommonSearchCriteria for Invoices */}
      {!showQuotes &&
        <div className="columns">
          <div className="column">
            <CommonSearchCriteria
              orderStatusOptions={invoiceStatusList}
              onSearch={handleSearchCriteria}
            />
          </div>
        </div>
      }

      {/* Render Quotes or Invoices Component based on the state */}
      {showQuotes ? <Quotes /> : (invoicesData !== null && <InvoicesTable invoicesData={invoicesData} />)}

      {/* Common Loader */}
      <CommonLoader loading={loading} />
    </div>
  );
};

export default Invoices;
